import { render, staticRenderFns } from "./tenant-img.vue?vue&type=template&id=93a25e2e&scoped=true"
import script from "./tenant-img.vue?vue&type=script&lang=js"
export * from "./tenant-img.vue?vue&type=script&lang=js"
import style0 from "./tenant-img.vue?vue&type=style&index=0&id=93a25e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a25e2e",
  null
  
)

export default component.exports